import React, { useEffect } from "react";
import "./App.css";
import "./index.css";
import { Route, Routes } from "react-router-dom"; import AOS from "aos";
import "aos/dist/aos.css";
import Header from "./components/header/Header"
import Footer from "./components/footer/Footer"
import Home from "./components/home/Home";
import About_us from "./components/about-us/About_us";
import Terms_And_Condition from "./components/terms-and-condition/Terms_And_Condition";
import Privacy_Policy from "./components/privacy-policy/Privacy_Policy";
import Contact_us from "./components/contact-us/Contact_us";
import ScrollToTop from "./components/ScrollTotop/ScrollTotop";
import Cancellation_Policy from "./components/cancellation-policy/Cancellation_Policy";


function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
    });
  }, []);
  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About_us />} />
        <Route path="/contact-us" element={<Contact_us/>} />
        <Route path="/terms-and-condition" element={<Terms_And_Condition />} />
        <Route path="/privacy-policy" element={<Privacy_Policy />} />
         <Route path="/cancellation-policy" element={<Cancellation_Policy />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
